import React, { memo } from 'react'
import styled from 'styled-components'
import { Flex, Button, getPaletteColor } from 'pcln-design-system'
import FooterHint from '../FooterHint/FooterHint'

interface IFooterProps {
  dismissCalendar: (evt) => void
  roundedCorners?: boolean
}

const FooterFlex = styled(Flex)`
  background: ${getPaletteColor('background.lightest')};
  border-top: 1px solid ${getPaletteColor('border.base')};
  ${(props) => props.theme.mediaQueries[1]} {
    box-shadow: ${(props) => (props.boxShadow ? props.theme.shadows['overlay-lg'] : 'none')};
    height: auto;
  }
  z-index: 1000;
`

function Footer({ dismissCalendar, roundedCorners }: IFooterProps) {
  return (
    <FooterFlex
      borderRadius={roundedCorners ? '2xl' : undefined}
      rounded={roundedCorners ? 'bottom' : undefined}
      p={2}
      width={[1]}
      justifyContent='space-between'
      alignItems='center'
    >
      <FooterHint />
      <Button aria-label='Dismiss calendar' size='small' variation='plain' onClick={dismissCalendar}>
        Done
      </Button>
    </FooterFlex>
  )
}

export default memo(Footer)
